export const getRoutWithId = (path: string, id: string, isSlash = false) => {
  return !isSlash ? `${path}/${id}` : `${path}${id}/`;
};
